// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mO-z","isFullWidth":"nO-z","landingPageVideo":"oO-z","play":"pO-z","iframeVideo":"qO-z","playHidden":"rO-z","fullwidth":"sO-z"};